import React from 'react';
import CRMDashboard from './index';

/* The old Dashboard MB address. It is the one Dashboard, opened on the MB tab. */
const DashboardMB: React.FC = () => <CRMDashboard start='managed' />;

export default DashboardMB;
